// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__kIKHz","tab":"ProcedureTabs_tab__1KU0d"};